import axios from 'axios'

const API_PATH = 'api/v2/admins/provinces'

const ProvincesApiV2 = {
  /**
   * Get list of `Province`
   * @param {object} params uri parameter
   * @return {object} Collection of `Provinces`
   */
  get: async () => {
    const path     = `${API_PATH}`
    const response = axios.get(path)
    return response
  }
}

export default ProvincesApiV2
